/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiChargingConfigurationCompanyCodeGet$Json } from '../fn/charging-configuration/api-charging-configuration-company-code-get-json';
import { ApiChargingConfigurationCompanyCodeGet$Json$Params } from '../fn/charging-configuration/api-charging-configuration-company-code-get-json';
import { apiChargingConfigurationCompanyCodeGet$Plain } from '../fn/charging-configuration/api-charging-configuration-company-code-get-plain';
import { ApiChargingConfigurationCompanyCodeGet$Plain$Params } from '../fn/charging-configuration/api-charging-configuration-company-code-get-plain';
import { apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json } from '../fn/charging-configuration/api-charging-configuration-get-by-charger-id-and-connector-id-charger-id-connector-id-get-json';
import { ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Params } from '../fn/charging-configuration/api-charging-configuration-get-by-charger-id-and-connector-id-charger-id-connector-id-get-json';
import { apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain } from '../fn/charging-configuration/api-charging-configuration-get-by-charger-id-and-connector-id-charger-id-connector-id-get-plain';
import { ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Params } from '../fn/charging-configuration/api-charging-configuration-get-by-charger-id-and-connector-id-charger-id-connector-id-get-plain';
import { apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json } from '../fn/charging-configuration/api-charging-configuration-get-charging-configuration-with-parking-place-and-parking-spots-by-parking-place-id-get-json';
import { ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Params } from '../fn/charging-configuration/api-charging-configuration-get-charging-configuration-with-parking-place-and-parking-spots-by-parking-place-id-get-json';
import { apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain } from '../fn/charging-configuration/api-charging-configuration-get-charging-configuration-with-parking-place-and-parking-spots-by-parking-place-id-get-plain';
import { ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Params } from '../fn/charging-configuration/api-charging-configuration-get-charging-configuration-with-parking-place-and-parking-spots-by-parking-place-id-get-plain';
import { apiChargingConfigurationPost$Json } from '../fn/charging-configuration/api-charging-configuration-post-json';
import { ApiChargingConfigurationPost$Json$Params } from '../fn/charging-configuration/api-charging-configuration-post-json';
import { apiChargingConfigurationPost$Plain } from '../fn/charging-configuration/api-charging-configuration-post-plain';
import { ApiChargingConfigurationPost$Plain$Params } from '../fn/charging-configuration/api-charging-configuration-post-plain';
import { apiChargingConfigurationPut$Json } from '../fn/charging-configuration/api-charging-configuration-put-json';
import { ApiChargingConfigurationPut$Json$Params } from '../fn/charging-configuration/api-charging-configuration-put-json';
import { apiChargingConfigurationPut$Plain } from '../fn/charging-configuration/api-charging-configuration-put-plain';
import { ApiChargingConfigurationPut$Plain$Params } from '../fn/charging-configuration/api-charging-configuration-put-plain';
import { ChargingConfiguration } from '../models/charging-configuration';

@Injectable({ providedIn: 'root' })
export class ChargingConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiChargingConfigurationCompanyCodeGet()` */
  static readonly ApiChargingConfigurationCompanyCodeGetPath = '/api/ChargingConfiguration/{companyCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationCompanyCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationCompanyCodeGet$Plain$Response(params: ApiChargingConfigurationCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationCompanyCodeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationCompanyCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationCompanyCodeGet$Plain(params: ApiChargingConfigurationCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationCompanyCodeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationCompanyCodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationCompanyCodeGet$Json$Response(params: ApiChargingConfigurationCompanyCodeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationCompanyCodeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationCompanyCodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationCompanyCodeGet$Json(params: ApiChargingConfigurationCompanyCodeGet$Json$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationCompanyCodeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /** Path part for operation `apiChargingConfigurationPut()` */
  static readonly ApiChargingConfigurationPutPath = '/api/ChargingConfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPut$Plain$Response(params?: ApiChargingConfigurationPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPut$Plain(params?: ApiChargingConfigurationPut$Plain$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPut$Json$Response(params?: ApiChargingConfigurationPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationPut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPut$Json(params?: ApiChargingConfigurationPut$Json$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationPut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /** Path part for operation `apiChargingConfigurationPost()` */
  static readonly ApiChargingConfigurationPostPath = '/api/ChargingConfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPost$Plain$Response(params?: ApiChargingConfigurationPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPost$Plain(params?: ApiChargingConfigurationPost$Plain$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPost$Json$Response(params?: ApiChargingConfigurationPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingConfigurationPost$Json(params?: ApiChargingConfigurationPost$Json$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /** Path part for operation `apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet()` */
  static readonly ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGetPath = '/api/ChargingConfiguration/GetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Response(params?: ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain(params?: ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Response(params?: ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json(params?: ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /** Path part for operation `apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet()` */
  static readonly ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGetPath = '/api/ChargingConfiguration/GetByChargerIdAndConnectorId/{chargerId}/{connectorId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Response(params: ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain(params: ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Response(params: ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
    return apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json(params: ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Params, context?: HttpContext): Observable<ChargingConfiguration> {
    return this.apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingConfiguration>): ChargingConfiguration => r.body)
    );
  }

}
